<script>
  import { _ } from 'svelte-i18n'
  import { modals, buy_modal_initiator, previews_search_filter, demos, chosen_theme, previews_tracking, previews_are_highlighted, previews_scrolled_down, user, buy_modal_counter, previews_sort_order, currency_sale, detected_fonts, hobby_font_limit, user_installed_fonts_count } from '../../stores'
  import { createEventDispatcher } from 'svelte'
  import { getCurrencySymbol } from '../../modules/visitorCountry'
  import { pro_monthly_price_details, pro_yearly_price_details, business_monthly_price_details, business_yearly_price_details } from '../../stores'
  import Modal from '../../elements/Modal.svelte'
  import TimesButton from '../../elements/TimesButton.svelte'
  import SubscribeButton from '../SubscribeButton.svelte'
  import Faq from '../../content/Faq.svelte'
  import HorizontalOptionsList from '../../elements/HorizontalOptionsList.svelte'
  import BuyModalIntentTitle from '../BuyModalIntentTitle.svelte'
  import PraiseAndPress from '../../content/PraiseAndPress.svelte'
  import Button from '../../elements/Button.svelte'

  const modal_id = 'buy'
  const dispatch = createEventDispatcher()
  
  let showAllFeatures = false
  let fontLimitText = "Upgrade when your font collection grows."
  
  $: if ($user_installed_fonts_count) {
    fontLimitText = $user_installed_fonts_count.length > $hobby_font_limit
      ? `Upgrade to preview all of your ${$detected_fonts.length} fonts.`
      : "Upgrade when your font collection grows."
  }
  
  // Feature data for Pro plan
  const proFeatures = [
  { title: $_('modals.features.unlimitedTitle'), description: "" },
  { title: $_('modals.features.taggingTitle'), description: $_('modals.features.tagging'), icon: "tags" },
  { title: $_('modals.features.exportTitle'), description: $_('modals.features.export'), icon: "save" },
  { title: $_('modals.features.printTitle'), description: $_('modals.features.print'), icon: "printer" },
  { title: $_('modals.features.useGoogleTitle'), description: $_('modals.features.google'), icon: "google" },
  { title: $_('modals.features.accessAllTitle'), description: $_('modals.features.characterMap'), icon: "glyph" },
  { title: $_('modals.features.previewTitle'), description: $_('modals.features.droppedFonts'), icon: "save-selection" },
  { title: $_('modals.features.saveTitle'), description: $_('modals.features.saveSelection'), icon: "save-selection" },
  { title: $_('modals.features.searchTitle'), description: $_('modals.features.search'), icon: "search" },
  { title: $_('modals.features.highlightTitle'), description: $_('modals.features.highlight'), icon: "highlight" },
  { title: $_('modals.features.autoscrollTitle'), description: $_('modals.features.autoscroll'), icon: "back-to-top", iconClass: "icon-autoscroll" },
  { title: $_('modals.features.noPromotionsTitle'), description: "" },
  ]

  
  let expired = false
  let selected_plan = "yearly"
  
  let plans = [
  {value:'yearly', display:'Pay yearly, save 25%'},
  {value:'monthly', display:'Pay monthly'}
  ]
  
  // Calculate pro prices
  $: currency = $pro_yearly_price_details?.currency || "USD"
  $: currency_symbol = getCurrencySymbol(currency)
  
  $: monthly_price = $pro_monthly_price_details?.price || 3
  $: yearly_price = $pro_yearly_price_details?.price || 36
  $: yearly_monthly_display_price = Math.floor(yearly_price/12*100)/100
  
  // Calculate business prices
  $: business_monthly_price = $business_monthly_price_details?.price || 7
  $: business_yearly_price = $business_yearly_price_details?.price || 72
  $: business_yearly_monthly_display_price = Math.floor(business_yearly_price/12*100)/100
  $: if ($user) {
    expired = $user.expired
  }
  
  function revertProAction() {
    if (demos.valid($buy_modal_initiator)) return
    switch ($buy_modal_initiator) {
      case 'search':
       previews_search_filter.set('')
       break
      case 'google':
        dispatch('closeGoogleFonts')
        window.scrollTo(0, 0)
        break
      case 'theme':
        $chosen_theme = "light"
        break
      case 'sorting':
        $previews_sort_order = 'ascending'
        break
      case 'tracking':
        $previews_tracking = 0
        break
      case 'highlight':
        $previews_are_highlighted = false
        break
      case 'autoscroll':
        $previews_scrolled_down = false
        break
      case 'fontdrop':
        dispatch('removeDroppedFonts')
        break
    }
    $buy_modal_counter++
    if( $buy_modal_counter === 3 && typeof window.hj !== "undefined" ) {
      hj('stateChange', 'buymodalclosed')
    }
    $buy_modal_initiator = undefined
  }
  
</script>

<Modal id={modal_id} on:modalClosed={revertProAction} buy flush_header>
  <span slot="header">
    <span class="black_header">
      {$_('modals.buy.subscribe')} {$_('modals.buy.plans')}
    </span>
    <BuyModalIntentTitle/>
    <TimesButton on:click={() => { revertProAction(); modals.close() }}/>
  </span>
  
  <div class="content_wrapper" slot="content">
    <!-- Plan selection toggle at the top -->
    <div class="plan_selector">
      <HorizontalOptionsList pill_shaped={true} list_options={plans} bind:selected_option={selected_plan}/>
    </div>
    
    <!-- Three column layout for plans -->
    <div class="plans_container">
      <!-- Hobby Column -->
      <div class="plan_column">
        <!-- Hobby Plan -->
        <div class="plan_card">
          <h3 class="plan_title pale">Hobby</h3>
          <div class="plan_description">
            <p>
              The most practical way to preview, compare, and choose fonts. Since 2011!
            </p>
            <p class="plan_feature_block">
              <b class="accent">Preview up to {$hobby_font_limit} fonts</b><br>
              {fontLimitText}
            </p>
            <p class="plan_feature_block">
              <b>Contains promotions</b><br>
              We promote our own features instead of third-party ads.
            </p>
          </div>
          <div class="price_container">
            <h2 class="price">
              Free
            </h2>
            <p class="price_description">
              <b>Free to use for personal projects</b>
              <br><small>Upgrade for unlimited previews, more features and help keep Wordmark ad-free and focused on your experience.</small>
            </p>
          </div>
        </div>

        <!-- Additional plans -->
        <div class="additional_plans">
          <p>
            We also offer free Pro plans for students and educators, and accessible pricing for those who can&rsquo;t currently afford the full price.
            <br><b>Just contact us to apply</b>
          </p>
        </div>
      </div>
      
      <!-- Pro Column -->
      <div class="plan_column">
        <!-- Pro Plan -->
        <div class="plan_card">
          <h3 class="plan_title">Pro</h3>
          <div class="plan_description">
            <p>
              Loved by thousands of creatives who work with fonts every day.
            </p>
            <ul class="features_list">
              {#each proFeatures.slice(0, showAllFeatures ? proFeatures.length : 7) as feature, index}
              <li class:has-description={feature.description}>
                <span class="feature-title">
                  {#if index === 0}
                    <b class="accent">{@html feature.title}</b>
                  {:else}
                    {@html feature.title}
                  {/if}
                  {#if feature.description}
                    <span class="question-mark">?</span>
                  {/if}
                </span>
                {#if feature.description}
                  <div class="feature-description">
                    {@html feature.description}
                  </div>
                {/if}
              </li>
              {/each}
              {#if proFeatures.length > 7 && !showAllFeatures}
                <li class="show-all">
                  <Button kind='outline' size='tiny' on:click={() => showAllFeatures = !showAllFeatures}>
                    See all features
                  </Button>
                </li>
              {/if}
            </ul>
          </div>
          <div class="price_container">
            <h2 class="price">
              {currency_symbol}{selected_plan === 'yearly' ? yearly_monthly_display_price : monthly_price}
              {selected_plan === 'yearly' ? '/month, billed annually' : '/month'}
            </h2>
            <p class="price_description">
              {#if selected_plan === 'yearly'}
                <b>Save 25% with yearly plan</b>
                <br>
                <small>
                  {#if $currency_sale}
                    <span class="underline">Reduced price</span> for your currency<br>
                  {/if}
                  <span class="underline">Full refund within 30 days</span> if it&rsquo;s not for you
                </small>
              {:else}
                {#if $currency_sale}
                  <b>Reduced price</b> for your currency<br>
                {/if}
                <b>Pay as you go.</b> <small>Cancel anytime. Upgrade to yearly if it becomes part of your workflow.</small>
              {/if}
            </p>
            <SubscribeButton {selected_plan} subscription_type="pro"/>
          </div>

        </div>
        <!-- Login -->
        {#if $user === undefined}
          <div class="login_text">
            <b>{$_('modals.buy.already')}</b>
            <!-- svelte-ignore a11y-invalid-attribute -->
            <a href="#" on:click|preventDefault={() => modals.open('login')}>{$_('modals.buy.click')}</a>
          </div>
        {/if}
      </div>
      
      <!-- Business Column -->
      <div class="plan_column">
        <!-- Business Plan -->
        <div class="plan_card">
          <h3 class="plan_title">Business</h3>
          <div class="plan_description">
            <p>
              Built for businesses offering customizable products. New in 2025!
            </p>
            <div class="plan_feature_block">
              <b class="accent">Storefronts—shareable font preview pages</b>
              <ul class="features_list">
                <li>Let customers preview their text in your fonts</li>
                <li>Multiple storefronts for different needs</li>
                <li>Share unique URL or add to your website</li>
                <li>Integration help included</li>
              </ul>
            </div>
            <div class="plan_feature_block">
              <b>Uploaded fonts—access them everywhere</b>
              <ul class="features_list">
                <li>Upload fonts to your account</li>
                <li>Work on your tablet or mobile</li>
                <li>Preview fonts on any browser</li>
              </ul>
            </div>
            <div class="plan_feature_block">
              <b><span class="plus">+</span> all Pro features</b>
            </div>
          </div>
          <div class="price_container">
            <h2 class="price">
              {currency_symbol}{selected_plan === 'yearly' ? business_yearly_monthly_display_price : business_monthly_price}
              {selected_plan === 'yearly' ? '/month, billed annually' : '/month'}
            </h2>
            <p class="price_description">
              {#if selected_plan === 'yearly'}
                <b>Save 25% with yearly plan</b>
                <br>
                <small>
                  {#if $currency_sale}
                    <span class="underline">Reduced price</span> for your currency<br>
                  {/if}
                  <span class="underline">Full refund within 30 days</span>
                </small>
              {:else}
                {#if $currency_sale}
                  <b>Reduced price</b> for your currency<br>
                {/if}
                <b>Monthly plan to get started.</b> <small>Upgrade to yearly if it becomes part of your sales process.</small>
              {/if}
            </p>
            <SubscribeButton {selected_plan} subscription_type="business"/>
          </div>
        </div>
      </div>
    </div>

    <!-- Two column layout -->
    <div class="two_column_layout">

      <!-- Left column -->
      <div class="left_column">
        <!-- Customer Satisfaction -->
        <div class="section">
          <h2>Exceptional Customer Satisfaction</h2>
          <p>
            Over the years, we've been asking people how they&rsquo;d feel if they could no longer use the Pro features. <span class="underline"><b>76.1%</b> responded that they&rsquo;d be very disappointed,</span> <b>20.2%</b> would be somewhat disappointed, and only <b>3.7%</b> said they&rsquo;d be indifferent.
          </p>
          <p>
            <span class="underline">That&rsquo;s nearly double the industry standard.</span> But more importantly, it shows that people who&rsquo;ve used Pro features rely on Wordmark—it&rsquo;s part of their routine, not just a nice-to-have. If you work with fonts often, there&rsquo;s a good chance it&rsquo;ll become part of yours too.
          </p>
        </div>
        <div class="section">
          <h2>It&rsquo;s Okay If It Doesn&rsquo;t Work Out</h2>
          <p>
            We know committing to a subscription can feel uncertain. That&rsquo;s why <span class="underline">we always honor refund requests.</span> No forms, no hassle. If it&rsquo;s not what you expected, just let us know (within 30 days for yearly plans) and we&rsquo;ll refund you in full. We&rsquo;ve never turned down a refund request, and we believe that&rsquo;s part of why customer satisfaction is so high.
          </p>
        </div>
        <div class="section">
          <h2>Proudly Owner-Operated</h2>
          <p>
            Wordmark has been independently built and maintained by Fahri Özkaramanli since 2011—without a team, investors, or outside funding. It&rsquo;s a calm, focused tool designed to help you work better with fonts. <span class="underline">When you subscribe, you are supporting a small business</span> committed to keeping Wordmark useful, sustainable, and aligned with your needs.
          </p>
        </div>

        <!-- FAQ section -->
        <div class="section">
          <h2>You Might Be Wondering</h2>
          <Faq/>
        </div>
      </div>

      <!-- Right column -->
      <div class="right_column">
        <PraiseAndPress/>
      </div>
    </div>
  </div>
</Modal>

<style>
  .black_header {
    color: var(--c-text);
    font-family: var(--PensumDisplay);
  }
  .content_wrapper {
    margin: 0 auto;
  }
  .plan_selector {
    display: flex;
    justify-content: center;
    margin: -1.8rem 0 4rem;
  }
  .plans_container {
    display: flex;
    gap: 2rem;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 2rem;
    font-variant-numeric: lining-nums;
  }
  .plan_column {
    flex: 1;
    min-width: 250px;
    display: flex;
    flex-direction: column;
  }
  .plan_card {
    position: relative;
    display: flex;
    flex-direction: column;
    margin-bottom: auto;
  }
  .plan_title {
    position: relative;
    z-index: 1;
    width: fit-content;
    margin: 0 0 -0.7rem 2rem;
    font-size: 2.4rem;
    font-family: var(--PensumDisplay);
    color: var(--c-accent);
  }
  .plan_title.pale {
    color: var(--c-text);
  }
  .plan_title:before {
    content: " ";
    position: absolute;
    display: block;
    width: calc(100% + 1.5rem);
    height: calc(100% + 1rem);
    margin-left: -0.75rem;
    margin-top: -0.4rem;
    background: gold;
    z-index: -1;
    transform: rotate(358deg);
  }
  .plan_title.pale:before {
    background: var(--c-bg);
  }
  .price_container {
    padding: 2rem;
    border: 1px solid var(--c-pill-bg);
    border-top: 0;
  }
  .plan_description {
    border: 1px solid var(--c-bg);
    background: var(--c-humane-bg);
    padding: 2.5rem 2rem;
  }
  .plan_description p {
    margin-bottom: 1.5rem;
  }
  .price {
    margin-bottom: 0.5rem;
    font-family: var(--PensumSans-Bold);
    font-size: 2.1rem;
    font-style: normal;
    font-variant-numeric: lining-nums;
    letter-spacing: -0.5px;
    color: var(--c-text);
  }
  .price_description {
    margin-bottom: 1.5rem;
  }
  .price_description small {
    display: inline;
    color: var(--c-text);
  }
  .features_list {
    list-style-type: none;
    padding: 0;
    flex-grow: 1;
  }
  .features_list li {
    max-width: 100%; /* used by child description width */
    position: relative;
    padding-left: 2rem;
    font-size: 1.4rem;
    line-height: 2.4rem;
    font-variant-numeric: lining-nums;
  }
  .features_list li.has-description {
    cursor: help;
  }
  .features_list li:before {
    content: " ";
    display: block;
    width: 0.6rem;
    height: 1rem;
    position: absolute;
    left: 0.3rem;
    top: 0.7rem;
    transform: rotate(45deg);
    border-right: 0.2rem solid var(--c-text-faded);
    border-bottom: 0.2rem solid var(--c-text-faded);
  }
  .feature-title {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }
  .question-mark {
    width: 1.7rem;
    height: 1.7rem;
    border-radius: 50%;
    background: var(--c-pill-bg);
    color: var(--c-text);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    font-family: var(--PensumSans-Bold);
    transition: background 0.2s ease, color 0.2s ease;
  }
  .question-mark::before {
    content: '';
    position: absolute;
    top: -0.5rem;
    border-width: 0.5rem;
    border-style: solid;
    border-color: transparent;
    transition: border-color 0.2s ease;

  }

  .has-description:hover {
    color: var(--c-accent);
  }
  .has-description:hover::before {
    border-color: var(--c-accent);
  }
  .has-description:hover .question-mark {
    background: var(--c-accent);
    color: var(--c-text-on-fill);
  }
  .has-description:hover .question-mark::before {
    border-color: var(--c-pill-bg-active) transparent transparent transparent;
  }

  .feature-description {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: calc(100% + 0.5rem);
    background: var(--c-pill-bg-active);
    color: var(--c-text-on-fill);
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;
    font-size: 1.4rem;
    line-height: 2rem;
    letter-spacing: 0.05px;
    z-index: 10;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease, visibility 0.2s ease;
    width: max-content;
    max-width: inherit;
    white-space: normal;
    pointer-events: none;
  }
  .has-description:hover .feature-description {
    opacity: 1;
    visibility: visible;
  }
  .plan_feature_block {
    margin-bottom: 1.5rem;
    font-size: 1.4rem;
  }
  .plan_feature_block b {
    font-family: var(--PensumSans-Bold);
  }
  .plan_feature_block .plus {
    font-family: var(--Helvetica);
    font-size: 1.8rem;
    padding: 0 0.4rem 0 0.2rem;
  }
  .plan_feature_block:last-child {
    margin-bottom: 0;
  }
  .login_text {
    padding: 2rem;
    font-size: 1.4rem;
    color: var(--c-text-faded);
  }
  a {
    color: var(--c-text-faded);
  }
  a:hover {
    color: var(--c-accent);
  }
  .accent {
    color: var(--c-accent);
  }
 
  .show-all {
    margin-top: 0.5rem;
  }
  .show-all:before {
    display: none !important;
  }

  .underline {
    display: inline;
    position: relative;
    z-index: 0;
    text-decoration: none;
    background-image: linear-gradient(to right, var(--c-gold) 0%, var(--c-gold) 100%);
    background-position: 0 0.85em;
    background-repeat: repeat-x;
    background-size: 100% 0.4em;
    padding: 0 0.25em;
    margin: 0 -0.25em;
    text-shadow: 1px 1px 1px var(--c-content-bg);
  }

  .additional_plans {
    margin-top: 1.9rem;
    padding: 2rem;
    font-size: 1.4rem;
    color: var(--c-text-faded);
  }
  .two_column_layout {
    display: flex;
    gap: 2rem;
    margin-top: 4rem;
  }
  .two_column_layout h2 {
    color: var(--c-text);
    font-family: var(--PensumDisplay);
    margin-bottom: 1.5rem;
  }
  .left_column {
    flex: 0 0 calc(66.66% - 1rem); /* Two-thirds of the container minus half the gap */
    max-width: calc(66.66% - 1rem);
  }
  .right_column {
    flex: 0 0 calc(33.33% - 1rem);
    max-width: calc(33.33% - 1rem);
    padding: 0 2rem;
  }

  .section {
    padding: 2rem;
    margin-bottom: 2rem;
    max-width: 72rem;
  }
  .section p {
    font-size: 2.1rem;
    margin-bottom: 1.5rem;
    line-height: 3rem;
    letter-spacing: -0.4px;
  }

  @media (max-width: 960px) {
    .plans_container {
      flex-direction: column;
      align-items: center;
    }
    .plan_column {
      max-width: 100%;
      width: 100%;
    }
    .two_column_layout {
      flex-direction: column;
    }
    .left_column,
    .right_column {
      flex: 0 0 100%;
      max-width: none;
    }
    .section {
      padding-left: 0;
      padding-right: 0;
    }
  }

  

</style> 